import {
  isValidPhoneNumber as _isValidPhoneNumber,
  parsePhoneNumberWithError,
} from 'libphonenumber-js';
import { z } from 'zod';

export const errorMessage = 'Invalid Australian phone number';

export const isValidPhoneNumber = (value: string) => {
  try {
    if (!_isValidPhoneNumber(value, 'AU')) return false;
    const phoneNumber = parsePhoneNumberWithError(value, 'AU');
    return phoneNumber.country === 'AU';
  } catch {
    return false;
  }
};

export const phoneNumberSchema = z
  .string()
  .min(1, 'Required field')
  .refine((value) => isValidPhoneNumber(value), { message: errorMessage });

export const optionalPhoneNumberSchema = z.string().refine(
  (value) => {
    if (!value || value.trim() === '') return true;
    return isValidPhoneNumber(value);
  },
  { message: errorMessage },
);
